<p>c4g-auth works!</p>
